import type { AxiosResponse } from "axios";
import { toast } from "vue3-toastify";
import type { ArticlePart } from "~/components/articles/articleTypes";

export type Category = {
  _id: string;
  name: string;
  frontRoute: string;
};

export type ArticleShow = {
  article: ArticlePart;
  nextArticle: string;
  previousArticle: string;
  nextPart: string;
  previousPart: string;
};

export const useArticleStore = defineStore("article", () => {
  const categories = ref<Category[]>([]);
  const article = ref<ArticlePart | null>(null);
  const articleShow = ref<ArticleShow | null>(null);
  // const articles = ref<PaginatedData<ArticlePart>>({
  //   data: [],
  //   pagination: {
  //     total: 0,
  //     page: "1",
  //     limit: "10",
  //     next: "",
  //     prev: "",
  //   },
  // });
  const $privateApi: any = useNuxtApp().$privateApi;

  const getCategories = async () => {
    try {
      const response = await $privateApi.get("/api/bo/article/categories");
      categories.value = response.data;
    } catch (error) {
      toast.error(
        "Une erreur est survenue lors de la récupération des catégories" +
          error,
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    }
  };

  // const getArticles = async (
  //   categoryId: string,
  //   page: number = 1,
  //   limit: number = 10
  // ) => {
  //   try {
  //     const response: AxiosResponse<PaginatedData<ArticlePart>> =
  //       await $privateApi.get(
  //         `/api/bo/article/list?category=${categoryId}&page=${page}&limit=${limit}`
  //       );
  //     articles.value = response.data;
  //     return response.data;
  //   } catch (error) {
  //     toast.error(
  //       "Une erreur est survenue lors de la récupération des articles" + error
  //     );
  //   }
  // };

  const getArticle = async (articleId: string) => {
    try {
      const response: AxiosResponse<ArticlePart> = await $privateApi.get(
        `/api/bo/article/${articleId}`
      );
      article.value = response.data;
    } catch (error) {
      toast.error(
        "Une erreur est survenue lors de la récupération de l'article" + error
      );
    }
  };

  const showArticle = async (articleId: string) => {
    try {
      const response: AxiosResponse<
        ArticleShow & {
          nextArticle: string;
          previousArticle: string;
          nextPart: string;
          previousPart: string;
        }
      > = await $privateApi.get(`/api/bo/article/${articleId}/show`);
      articleShow.value = response.data;
    } catch (error) {
      toast.error(
        "Une erreur est survenue lors de la récupération de l'article" + error
      );
    }
  };

  return {
    categories,
    getCategories,
    // getArticles,
    getArticle,
    article,
    articleShow,
    showArticle,
    // articles,
  };
});
